import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import * as helper from '../../../../helper/index';
import API from '../../../create/api';
import Grid from '@mui/material/Grid';
import Timeline from '@mui/lab/Timeline';
import TimelineItem from '@mui/lab/TimelineItem';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineContent from '@mui/lab/TimelineContent';
import TimelineDot from '@mui/lab/TimelineDot';
import TimelineOppositeContent from '@mui/lab/TimelineOppositeContent';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import CommentIcon from '@mui/icons-material/Comment';
import DoubleArrowIcon from '@mui/icons-material/DoubleArrow';
import moment from 'moment-timezone';
import Comment from './components/comment';

export default function ViewParcel() {
  const { id }: any = useParams();

  const [get_companies, set_companies]: [any[], any] = useState([]);
  const [get_riders, set_riders]: [any[], any] = useState([]);
  const [get_areas, set_areas]: [any[], any] = useState([]);
  const [get_parcel, set_parcel]: any = useState({});
  const [get_logs, set_logs]: any = useState([]);

  async function get_extra_info() {
    await Promise.all([
      API.getAll(`${process.env.REACT_APP_API_SERVER}/companies`),
      API.getAll(`${process.env.REACT_APP_API_SERVER}/riders`),
      API.getAll(`${process.env.REACT_APP_API_SERVER}/areas`),
    ])
      .then(([companies, riders, areas]) => {
        set_companies(companies);
        set_riders(riders);
        set_areas(
          (areas as any[]).sort((areaA: any, areaB: any) => {
            const letterA = String(areaA?.name?.[0] ?? '').toUpperCase();
            const letterB = String(areaB?.name?.[0] ?? '').toUpperCase();
            if (letterA < letterB) return -1;
            if (letterA > letterB) return 1;
            return 0;
          }),
        );
      })
      .catch((e) => {
        helper.axiosErrorHandling(e);
      });
  }
  useEffect(() => {
    get_extra_info();
  }, []);

  async function parcel_info() {
    const url = `${process.env.REACT_APP_API_SERVER}/parcels/${id}`;
    const [parcel]: any[] = await Promise.all([API.getAll(url)]);

    parcel.companyName = get_companies.find((company: any) => company.id === parcel.company_id)?.name;

    parcel.riderName = get_riders.find((rider: any) => String(rider.id) === String(parcel.rider))?.name;

    parcel.areaName = get_areas.find((a: any) => String(a.id) === String(parcel.area))?.name;

    const logs = get_logs;
    const created = {
      created_at: parcel.created_at,
      details: 'Created',
      type: 'created',
    };
    if (
      get_logs.findIndex((log: { created: string; details: string; type: string }) => log.type === 'created') === -1
    ) {
      logs.push(created);
    }
    for (let i = 0; i < (parcel?.parcel_logs ?? []).length; i++) {
      const parcel_log = parcel?.parcel_logs[i];
      const check_log_exists = get_logs.findIndex(
        (log: { created: string; details: string; type: string; id: number }) => log.id === parcel_log.id,
      );

      if (check_log_exists === -1) {
        logs.push(parcel_log);
      }
    }
    set_logs(logs);

    set_parcel(parcel);
  }

  useEffect(() => {
    parcel_info();
    // eslint-disable-next-line
  }, [get_companies, get_riders, get_areas]);

  function get_icon(type: string) {
    if (type === 'created') {
      return <AccessTimeIcon />;
    }

    if (type === 'comment') {
      return <CommentIcon />;
    }

    if (type === 'status') {
      return <DoubleArrowIcon />;
    }

    return <TimelineDot />;
  }

  return (
    <Grid container>
      <Grid container xs={12} md={8}>
        <div>
          <Grid container spacing={2}>
            <Grid item xs={4} md={2}>
              <div>
                <b>ID:</b>
              </div>
            </Grid>
            <Grid item xs={8} md={2}>
              <div>{get_parcel.id}</div>
            </Grid>

            <Grid item xs={4} md={2}>
              <div>
                <b>Status:</b>
              </div>
            </Grid>
            <Grid item xs={8} md={2}>
              <div>{get_parcel.status}</div>
            </Grid>

            <Grid item xs={4} md={2}>
              <div>
                <b>Invoice no:</b>
              </div>
            </Grid>
            <Grid item xs={8} md={2}>
              <div>{get_parcel.memoNo}</div>
            </Grid>

            <Grid item xs={4} md={2}>
              <div>
                <b>Customer Name:</b>
              </div>
            </Grid>
            <Grid item xs={8} md={2}>
              <div>{get_parcel.customerName}</div>
            </Grid>

            <Grid item xs={4} md={2}>
              <div>Phone Number</div>
            </Grid>
            <Grid item xs={8} md={2}>
              <div>{get_parcel.phoneNumber}</div>
            </Grid>

            <Grid item xs={4} md={2}>
              <div>Address</div>
            </Grid>
            <Grid item xs={8} md={2}>
              <div>{get_parcel.address}</div>
            </Grid>

            <Grid item xs={4} md={2}>
              <div>Cash On Delivery</div>
            </Grid>
            <Grid item xs={8} md={2}>
              <div>{get_parcel.COD}</div>
            </Grid>

            <Grid item xs={4} md={2}>
              <div>Delivery Charge</div>
            </Grid>
            <Grid item xs={8} md={2}>
              <div>{get_parcel.deliveryCharge}</div>
            </Grid>

            <Grid item xs={4} md={2}>
              <div>Total</div>
            </Grid>
            <Grid item xs={8} md={2}>
              <div>{get_parcel.amount}</div>
            </Grid>

            <Grid item xs={4} md={2}>
              <div>Company Name</div>
            </Grid>
            <Grid item xs={8} md={2}>
              <div>{get_parcel.companyName}</div>
            </Grid>

            <Grid item xs={4} md={2}>
              <div>Rider Name</div>
            </Grid>
            <Grid item xs={8} md={2}>
              <div>{get_parcel.riderName}</div>
            </Grid>

            <Grid item xs={4} md={2}>
              <div>Area Name</div>
            </Grid>
            <Grid item xs={8} md={2}>
              <div>{get_parcel.areaName}</div>
            </Grid>

            <Grid item xs={4} md={2}>
              <div>Created Date:</div>
            </Grid>
            <Grid item xs={8} md={2}>
              <div>{moment(get_parcel.created_at).format('DD-MMM-YYYY hh:mm a')}</div>
            </Grid>

            <Grid item xs={4} md={2}>
              <div>Updated Date:</div>
            </Grid>
            <Grid item xs={8} md={2}>
              <div>{moment(get_parcel.updated_at).format('DD-MMM-YYYY hh:mm a')}</div>
            </Grid>
            <Grid item xs={4} md={2}>
              <div>Weight:</div>
            </Grid>
            <Grid item xs={8} md={2}>
              <div>{get_parcel.weight}</div>
            </Grid>
            <Grid item xs={4} md={2}>
              <div>Details by Merchant:</div>
            </Grid>
            <Grid item xs={8} md={10}>
              <div>{get_parcel.details}</div>
            </Grid>
          </Grid>
        </div>
      </Grid>
      <Grid container xs={12} md={4}>
        <Grid item xs={12} md={12}>
          <Timeline>
            {get_logs.map((log: { created_at: string; details: string; type: string }, index: number) => {
              return (
                <TimelineItem key={index}>
                  <TimelineOppositeContent color="text.secondary">
                    {moment(log.created_at).format('DD-MMM-YYYY hh:mm a')}
                  </TimelineOppositeContent>
                  <TimelineSeparator>
                    {get_icon(log.type)}
                    <TimelineConnector />
                  </TimelineSeparator>
                  <TimelineContent>{log.details}</TimelineContent>
                </TimelineItem>
              );
            })}
          </Timeline>
        </Grid>

        <Grid item xs={12} md={12}>
          <Comment parcel_id={id} reload_parcel={parcel_info} />
        </Grid>
      </Grid>
    </Grid>
  );
}
